import styled from "styled-components";
import {baseColors} from "../../../../../../themes/definitions/casino888/base-colors";

export const GameJackpotBarContributionLabelDefaultBox = styled.span<{isOptInStatus?: boolean}>`
    font-size: 1.1rem;
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.2rem;
    }
    ${({theme}) => theme.font.presets.medium};
    color: ${({theme, isOptInStatus}) => isOptInStatus ? theme.colors.brandPrimary : baseColors.base04};
    line-height: 12px;
`;